<template>
    <header class="header-global">
        <base-nav class="navbar navbar-expand-lg navbar-dark bg-default" type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="/img/brand/roho-icon-only.png" style="float: left; height: 12rem; margin: 20px 0" alt="A logo with a orange pangolin surrounded by a blue circle. Brand name: Roho Network. Slogan: do better together.">
            </router-link>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
